import React from 'react'
import { Icon } from '../'
import styles from './Button.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const Button = props => (
  <div className={cx({
    'button-el': true,
    base: true,
    isSimple: props.simple,
    isDisabled: props.disabled,
    isOutlined: props.outline,
    isInversed: props.inversed,
    hasFullWidth: props.full,
  })} onClick={props.onClick} style={props.style}>
    <div>
      {props.label &&
        <div className={`button-label-el ${styles.label}`}>{props.label}</div>
      }
      {props.icon &&
        <div className={`button-icon-el ${styles.icon}`}><Icon name={props.icon} size="small" /></div>
      }
    </div>
  </div>
)

Button.defaultProps = {
  label: null,
  icon: null,
}

export default Button
